import {useTranslation} from 'react-i18next';
import {FormProvider, useForm} from 'react-hook-form';
import {useNavigate} from 'react-router-dom';
import {GROUP_TYPES, SelectOptionType} from '@guestapp/sdk';
import {PATHS} from 'routes/constants';
import {useGuestGroup, usePath} from 'hooks';
import {useOnboardingStore} from 'pages/Auth/store/useOnboardingStore';
import {StepInfoBox} from 'pages/Auth/components/StepInfoBox';
import {StyledReservationTypeForm} from './styled';

type FormTypes = {
  group_type: SelectOptionType<undefined, GROUP_TYPES>;
};

type Props = {
  disabled: boolean;
};
function ReservationTypeStep({disabled}: Props) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const formMethods = useForm<FormTypes>();
  const {handleSubmit} = formMethods;
  const {getFullPath} = usePath();
  const {guestGroup} = useGuestGroup();
  const groupType = useOnboardingStore(state => state.groupType);
  const setGroupType = useOnboardingStore(state => state.setGroupType);

  const onSubmit = (formData: FormTypes) => {
    setGroupType(formData.group_type?.value ?? GROUP_TYPES.family);
    navigate(getFullPath(PATHS.onboarding.numberOfGuests));
  };

  return (
    <>
      <StepInfoBox
        title={t('how_are_you_traveling')}
        description={t('choose_the_option_that_best_describes_this_reservation')}
      />
      <FormProvider {...formMethods}>
        <StyledReservationTypeForm
          onSubmit={handleSubmit(onSubmit)}
          groupType={groupType ?? guestGroup?.group_type ?? GROUP_TYPES.family}
          disabled={disabled}
          radioCustomBox
          className="onboarding__reservation-type-form"
        />
      </FormProvider>
    </>
  );
}

export {ReservationTypeStep};
